import React, { type HTMLAttributes } from 'react';

import GraphemeSplitter from 'grapheme-splitter';

import { useAppSelector } from '@pkg/hooks';

import { type EmojiId } from '@app/client';

// Note from Tim K:
// The stylesheet has been moved to the assets directory
// to avoid it being skipped in the bundler.

export interface YatSpriteProps extends HTMLAttributes<HTMLElement> {
    /** A string of yat-compatible emoji characters */
    emojiID: EmojiId;
    /** Force YatSprite to use the custom Yat image sprite instead of emoji characters */
    forceSprite?: boolean;
}

const graphemeSplitter = new GraphemeSplitter();

export function YatSprite({ className = '', emojiID, forceSprite, ...rest }: YatSpriteProps) {
    const { features } = useAppSelector((state) => state.featureFlags);

    if (!emojiID) return null;

    function renderGrapheme(emoji, i) {
        if (features.useSpriteForEmojis || forceSprite) {
            return (
                <span
                    {...rest}
                    role="img"
                    aria-label={emoji}
                    className={`yat-sprite yat-${emoji.replace(/\u{fe0f}/g, '')} ${className}`}
                    key={i}
                >
                    <picture className="yat-sprite__image">
                        <source
                            srcSet="/assets/img/yat-sprite.webp?ver=509a9115a25f3008c8de4ed9c401ef35"
                            width={1804}
                            height={1886}
                        />
                        <source
                            srcSet="/assets/img/yat-sprite.png?ver=591b2ea2d765ff6b7db65dc3b8dea097"
                            width={1804}
                            height={1886}
                        />
                        <img src="/assets/img/yat-sprite.png?ver=591b2ea2d765ff6b7db65dc3b8dea097" alt="yat sprite" loading="lazy" />
                    </picture>
                </span>
            );
        }

        return (
            <span {...rest} className={`yat-sprite__emoji-font ${className}`} key={i}>
                {emoji}
            </span>
        );
    }

    return <>{graphemeSplitter.splitGraphemes(emojiID).map(renderGrapheme)}</>;
}
